export default (function (x) { return function () { return x; }; });



//////////////////
// WEBPACK FOOTER
// ./node_modules/ag-charts-community/dist/es6/interpolate/constant.js
// module id = 3187
// module chunks = 0